import { useInvalidatePortfolios } from '@/entities/portfolio';
import { trpc } from '@/shared/api';
import { useAsyncAction } from '@/shared/lib';

export const useReorderPortfolios = () => {
  const mutation = trpc.portfolioManagement.items.reorder.useMutation();
  const action = useAsyncAction(mutation.mutateAsync, useInvalidatePortfolios());
  return { ...action, reorder: action.execute };
};
